import { Component, OnInit, ViewChildren } from "@angular/core";
import { AuthService } from "../auth.service";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
import * as CryptoJS from "crypto-js";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { SocialAuthService } from "angularx-social-login";
import { SocialUser } from "angularx-social-login";
import {
  GoogleLoginProvider,
  FacebookLoginProvider,
} from "angularx-social-login";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

declare global {
  interface Window {
    OneSignal: any;
  }
}

import firebase from "firebase";
import { TranslateService } from "@ngx-translate/core";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  model: any = {};
  encryptedData: any;
  passwordType: any = "password";
  private user: SocialUser;
  private loggedIn: boolean;
  param: any;
  app_language: any;
  publicId: any;
  decodeUrl: any;
  isLoading = false;
  oneSignalData: any = {};
  deviceId: any;
  deviceInfo: any;
  @ViewChildren("mail") email;
  event: any;
  index: any;
  slug: any;
  constructor(
    private loginService: AuthService,
    private route: Router,
    private toastr: ToastrService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private socialAuthService: SocialAuthService,
    private router: ActivatedRoute,
    private deviceService: DeviceDetectorService
  ) {
    this.param = this.router.queryParams.subscribe((params: any) => {
      this.event = params.event;
      this.publicId = params.public_id;
      this.index = params.index;
      this.slug = params.slug;
    });
    // if (localStorage.getItem('app_language')) {
    //   const language = JSON.parse(
    //     localStorage.getItem('app_language')
    //   );
    //   this.translate.setDefaultLang(language);
    // }
    // else {
    //   this.translate.setDefaultLang("en");
    // }
  }

  async ngOnInit() {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.deviceId = result.visitorId;

    if (localStorage.getItem(environment.localStorageLangKey)) {
      this.app_language = JSON.parse(
        localStorage.getItem(environment.localStorageLangKey)
      );
    }
    window.scrollTo(0, 0);
    if (localStorage.getItem("remember_me_admin")) {
      this.encryptedData = localStorage.getItem("remember_me_admin");
      this.encryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      this.model.email = this.encryptedData.email;
      this.model.password = this.encryptedData.password;
      this.model.remember_me = true;
    }

    this.socialAuthService.authState.subscribe((user) => {
      this.user = user;
      this.loggedIn = user != null;
    });
  }
  ngAfterViewInit() {
    this.email.first.nativeElement.focus();
  }
  /**
   * This function is use for login.
   * @param form
   */
  login(form) {
    if (form) {
      this.spinner.show();
      this.isLoading = true;
      const encryptedData = localStorage.getItem("oneSignalData");
      if (encryptedData) {
        this.oneSignalData = JSON.parse(
          CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
            CryptoJS.enc.Utf8
          )
        );
      }
      this.model.one_signal_id = this.oneSignalData.id;
      this.model.device_id = this.deviceId;
      this.model.dd = {
        os: this.deviceInfo.os,
        platform: this.deviceInfo.browser,
        make_model: "",
        push_device_token: "",
        device_type: "web",
        screen_resolution:
          window.screen.availHeight + "*" + window.screen.availWidth,
        device_unique_id: this.deviceId,
      };
      this.model.dod = {
        app_version: "1.0",
        os_version: this.deviceInfo.os_version,
        network_provider: "",
        network_type: "",
      };
      this.loginService.login(this.model).subscribe(
        (data) => {
          if (data) {
            if (environment.analyticsStatus) {
              const analytics = firebase.analytics();
              analytics.logEvent("userlogin");
            }
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.success(data.message, "Success!", {
              closeButton: true,
            });
            const user_data = data.results;
            user_data.deviceId = this.deviceId;
            user_data.people_profile = data.people_profile.results;
            user_data.profile_id = data?.people_profile?.results[0]?.id;
            if (this.model.remember_me) {
              const remember_me = CryptoJS.AES.encrypt(
                JSON.stringify(this.model),
                environment.secretkey
              ).toString();
              localStorage.setItem("remember_me_admin", remember_me);
            } else {
              localStorage.removeItem("remember_me_admin");
            }

            const app_promo = CryptoJS.AES.encrypt(
              JSON.stringify(user_data),
              environment.secretkey
            ).toString();
            localStorage.setItem(environment.localStorageKey, app_promo);
            if (localStorage.getItem(environment.localStorageKey)) {
              if (this.publicId || this.event) {
                if (this.event === "activation") {
                  this.route.navigate(["/activation"]);
                } else {
                  this.decodeUrl = JSON.parse(
                    CryptoJS.AES.decrypt(
                      this.publicId,
                      environment.secretkey
                    ).toString(CryptoJS.enc.Utf8)
                  );
                  let decod = decodeURIComponent(this.decodeUrl);
                  this.route.navigate([decod], {
                    state: {
                      event: this.event,
                      index: this.index,
                      slug: this.slug,
                    },
                  });
                }
              } else {
                if (data.results.is_free == "yes") {
                  this.route.navigate(["/home"]);
                } else {
                  if (data.results.subscription_type == null) {
                    this.route.navigate(["/subscription"]);
                  } else {
                    this.route.navigate(["/home"]);
                  }
                }
              }
            }
          }
        },
        (err) => {
          this.isLoading = false;

          if (err.status === 0) {
            this.spinner.hide();
            this.toastr.error("CONNECTION REFUSED", "OOPS!", {
              closeButton: true,
            });
          } else if (err.status === 500) {
            this.spinner.hide();
            this.toastr.error(err.datas.message, "OOPS!", {
              closeButton: true,
            });
          } else if (err.status === 404) {
            this.spinner.hide();
            this.toastr.error(err.datas.message, "OOPS!", {
              closeButton: true,
            });
          } else if (err.status === 401) {
            this.spinner.hide();
            this.toastr.error(err.datas.message, "OOPS!", {
              closeButton: true,
            });
          } else {
            this.spinner.hide();
            this.toastr.error(err.datas.message, "OOPS!", {
              closeButton: true,
            });
          }
        }
      );
    }
  }
  /**
   * This function is use for change password.
   */
  changePasswordType(): void {
    if (this.passwordType === "password") {
      this.passwordType = "text";
    } else {
      this.passwordType = "password";
    }
  }
  /**
   * This function is use for signIn with google.
   */
  signInWithGoogle(): void {
    this.socialAuthService
      .signIn(GoogleLoginProvider.PROVIDER_ID)
      .then((userInfo) => {
        const encryptedData = localStorage.getItem("oneSignalData");
        if (encryptedData) {
          this.oneSignalData = JSON.parse(
            CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
              CryptoJS.enc.Utf8
            )
          );
        }

        const data = {
          access_token: userInfo.idToken,
          email: userInfo.email,
          name: userInfo.name,
          image: userInfo.photoUrl,
          social_type: "google",
          device_type: "web",
          device_id: this.deviceId,
          one_signal_id: this.oneSignalData.id ? this.oneSignalData.id : "",
        };

        this.loginService.googleLogin(data).subscribe(
          (res) => {
            const login_user_info = JSON.parse(JSON.stringify(res.results));
            login_user_info.socialMediaUser = true;
            login_user_info.people_profile = res.people_profile.results;
            login_user_info.profile_id = res?.people_profile?.results[0]?.id;
            const user_info = CryptoJS.AES.encrypt(
              JSON.stringify(login_user_info),
              environment.secretkey
            ).toString();
            localStorage.setItem(environment.localStorageKey, user_info);
            if (res.results.subscription_type == null) {
              this.route.navigate(["/subscription"]);
            } else {
              this.route.navigate(["/home"]);
            }
          },
          (err) => {
            if (err.status === 0) {
              this.toastr.error("CONNECTION REFUSED", "Whoops!", {
                closeButton: true,
              });
            } else if (err.status === 500) {
              this.toastr.error(err.datas.message, "Whoops!", {
                closeButton: true,
              });
            } else if (err.status === 404) {
              this.toastr.error(err.datas.message, "Whoops!", {
                closeButton: true,
              });
            } else if (err.status === 401) {
              this.toastr.error(err.datas.message, "Whoops!", {
                closeButton: true,
              });
            } else {
              this.toastr.error(err.datas.message, "Whoops!", {
                closeButton: true,
              });
            }
          }
        );
      });
  }
  /**
   * This function is use for signIn with facebook.
   */
  signInWithFB(): void {
    this.socialAuthService
      .signIn(FacebookLoginProvider.PROVIDER_ID)
      .then((userInfo) => {
        const encryptedData = localStorage.getItem("oneSignalData");
        if (encryptedData) {
          this.oneSignalData = JSON.parse(
            CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
              CryptoJS.enc.Utf8
            )
          );
        }

        const data = {
          access_token: userInfo.authToken,
          email: userInfo.email,
          name: userInfo.firstName + " " + userInfo.lastName,
          image: userInfo.photoUrl,
          social_type: "facebook",
          device_type: "web",
          device_id: this.deviceId,
          one_signal_id: this.oneSignalData.id ? this.oneSignalData.id : "",
        };

        this.loginService.fbLogin(data).subscribe(
          (res) => {
            const login_user_info = JSON.parse(JSON.stringify(res.results));
            login_user_info.socialMediaUser = true;
            login_user_info.people_profile = res.people_profile.results;
            login_user_info.profile_id = res.people_profile.results[0].id;
            const user_info = CryptoJS.AES.encrypt(
              JSON.stringify(login_user_info),
              environment.secretkey
            ).toString();
            localStorage.setItem(environment.localStorageKey, user_info);

            if (res.results.subscription_type == null) {
              this.route.navigate(["/subscription"]);
            } else {
              this.route.navigate(["/home"]);
            }
          },
          (err) => {
            if (err.status === 0) {
              this.toastr.error("CONNECTION REFUSED", "Whoops!", {
                closeButton: true,
              });
            } else if (err.status === 500) {
              this.toastr.error(err.datas.message, "Whoops!", {
                closeButton: true,
              });
            } else if (err.status === 404) {
              this.toastr.error(err.datas.message, "Whoops!", {
                closeButton: true,
              });
            } else if (err.status === 401) {
              this.toastr.error(err.datas.message, "Whoops!", {
                closeButton: true,
              });
            } else {
              this.toastr.error(err.datas.message, "Whoops!", {
                closeButton: true,
              });
            }
          }
        );
      });
  }
}
